(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.landscapeQuery = window.matchMedia(
        '(orientation: landscape) and (max-height: 500px) and (max-width: 989px), ' +
        '(orientation: landscape) and (max-height: 500px) and (max-width: 1200px) and (pointer: coarse)'
      );
      this.onLandscapeChange = () => {
        if (this.landscapeQuery.matches) {
          this.header.classList.remove(
            'shopify-section-header-sticky', 'shopify-section-header-hidden',
            'scrolled-past-header', 'animate'
          );
        } else if (this.headerIsAlwaysSticky && !this.landscapeQuery.matches) {
          this.header.classList.add('shopify-section-header-sticky');
        }
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.createObserver();
        this.setHeaderHeight();
      };
      this.landscapeQuery.addEventListener('change', this.onLandscapeChange);
      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);
      this.widthQuery = window.matchMedia('(max-width: 990px)');
      this.onWidthChange = this.setHeaderHeight.bind(this);
      this.widthQuery.addEventListener('change', this.onWidthChange);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.landscapeQuery.removeEventListener('change', this.onLandscapeChange);
      this.widthQuery.removeEventListener('change', this.onWidthChange);
      this.headerResizeObserver.disconnect();
      if (this.boundsObserver) this.boundsObserver.disconnect();
    }
    createObserver() {
      if (this.boundsObserver) this.boundsObserver.disconnect();
      this.boundsObserver = new IntersectionObserver((entries, observer) => {
        const rect = entries[0].boundingClientRect;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.headerBounds = { top: rect.top + scrollTop, bottom: rect.bottom + scrollTop };
        observer.disconnect();
      });
      this.boundsObserver.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.landscapeQuery.matches) {
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky || this.landscapeQuery.matches) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky || this.landscapeQuery.matches) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky || this.landscapeQuery.matches) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
